export function isGeolocationAllowedByPolicy(): boolean {
  if (typeof document === 'undefined') return true;

  const policy: any = (document as any).permissionsPolicy || (document as any).featurePolicy;
  if (policy && typeof policy.allowsFeature === 'function') {
    try {
      return policy.allowsFeature('geolocation');
    } catch {
      return true;
    }
  }

  return true;
}
